<template>
  <app-modal-default class="field-info" @close="close">
    <template v-slot:header v-if="field">
      {{ field.name }}
    </template>

    <template v-slot:content v-if="field">
      <div class="about">
        <div class="a-row">
          <div class="a-column">
            <div class="title">{{ $ml.get(`Farm Name`) }}</div>
            <div class="value">{{ farm.name }}</div>
          </div>
          <!-- <div class="a-column">
            <div class="title">Field name</div>
            <div class="value">{{fieldInfo.field.name}}</div>
          </div> -->
          <div class="a-column">
            <div class="title">{{ $ml.get(`Field size`) }}</div>
            <div class="value">
              {{ $store.getters["unit/convert"]("ha", field.area) }}
              {{ $store.getters["unit/getLabel"]("ha") }}
            </div>
          </div>
          <!-- <div class="a-column">
            <div class="title">{{$ml.get(`Location`)}}</div>
            <div class="value" v-if="fieldWeather">{{ fieldWeather.name }}, {{ fieldWeather.sys.country }}</div>
          </div> -->
        </div>

        <div class="a-row" v-if="fieldWeather">
          <div class="a-column">
            <div class="title">{{ $ml.get(`Temperature`) }}</div>
            <!-- <div class="value">{{ fieldWeather.main.temp }}C</div> -->
            <div class="value">
              {{ parseFloat($store.getters['unit/convert']('C', fieldWeather.main.temp)).toFixed(1) }}
              {{ $store.getters['unit/getLabel']('C') }}
            </div>
          </div>
          <div class="a-column">
            <div class="title">{{ $ml.get(`Weather`) }}</div>
            <div class="value">{{ fieldWeather.weather[0].description }}</div>
          </div>
          <div class="a-column">
            <div class="title">{{$ml.get(`avg. wind speed`)}}</div>
            <div class="value">{{ $store.getters['unit/convert']('m/s', fieldWeather.wind.speed) }} {{$store.getters['unit/getLabel']('m/s')}}</div>
          </div>
          <div class="a-column">
            <div class="title">{{ $ml.get(`cloudy cover`) }}</div>
            <div class="value">{{ fieldWeather.clouds.all }}%</div>
          </div>
        </div>
        <div class="a-row" v-if="fieldWeather">
          <div class="a-column">
            <div class="title">{{ $ml.get(`Pressure`) }}</div>
            <div class="value">{{ fieldWeather.main.pressure }}</div>
          </div>
          <div class="a-column">
            <div class="title">{{ $ml.get(`humidity`) }}</div>
            <div class="value">{{ fieldWeather.main.humidity }}%</div>
          </div>
        </div>

        <div class="a-row buttons">
          <template
            v-if="
              field.shape == 'polygon' &&
                $whitelabel !== 'digifarm' &&
                $store.getters['user/data'].globalRole == 'admin'
            "
          >
            <app-btn
              @click="enableSatelliteView(field.id)"
              class="satellite"
              styling="outline"
            >
              <satellite-icon />
              {{ $ml.get("Satellite view") }}
            </app-btn>
          </template>

          <app-btn @click="deleteField(field.id)" :danger="true">{{
            $ml.get(`Delete field`)
          }}</app-btn>
        </div>
      </div>
    </template>
  </app-modal-default>
</template>

<script>
import API from "@/api";
import SatelliteIcon from "@/components/common/sidebar/icons/SatelliteIcon";

export default {
  props: {
    field: {
      required: true,
    },
  },
  data() {
    return {
      fieldWeather: null,
    };
  },
  methods: {
    enableSatelliteView(id) {
      this.$store.dispatch("satellite/open");
      this.$store.dispatch("satellite/selectField", id);
    },
    close() {
      this.$emit("close");
    },
    //=================================================================================
    deleteField(id) {
      this.$store.commit("modals/prompt/open", {
        onAccept: () => {
          return API.fields.deleteField(id).then((res) => {
            this.$emit("close");
            this.$store.dispatch("farms/updateData");
            try {
              let result = JSON.parse(JSON.stringify(res));
              console.log(result.data.message);
              if (result.data.message == 'Please buy a plan!') {
                this.$notify({
                  group: "notices",
                  title: this.$ml.get(
                    `Please buy a plan before deleting fields.`
                  ),
                  type: "error",
                });
              }
            } catch (e) {}
          });
        },
        onCancel: () => {},
        text: this.$ml.get(`Are you sure?`),
      });
    },
    //=================================================================================
    getWeather() {
      let coords = this.field.coordinates[0];
      let lang = this.$store.getters["user/data"].language;
      this.$axios
        .get(
          `https://api.openweathermap.org/data/2.5/weather?lat=${coords.latitude}&lon=${coords.longitude}&units=metric&lang=${lang}&APPID=19da28b2779cabb46852b7862b6873d9`
        )
        .then((res) => {
          this.fieldWeather = res.data;
        });
    },
  },
  computed: {
    farm() {
      return this.$store.getters["farms/getFarmById"](this.field.farmId);
    },
  },
  watch: {
    field: function(val) {
      this.getWeather();
    },
  },
  created() {
    this.getWeather();
  },
  components: {
    SatelliteIcon,
  },
};
</script>
<style lang="scss">
.field-info .--content {
  height: 100%;
}
</style>
<style lang="scss" scoped>
.field-info {
  // position: absolute;
  // top: 10px;
  // left: 10px;
  // z-index: 1000;
  // height: 100%;
  .about {
    height: 100%;
    display: flex;
    flex-direction: column;
    .a-row {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .a-column {
        flex-basis: 50%;
        // max-width: 25%;
        padding: 0 24px 16px 0;
        .title {
          // white-space: nowrap;
          font-size: 12px;
          text-transform: uppercase;
          color: #8b8d91;
        }
        .value {
          color: #4c5056;
          white-space: nowrap;
          font-size: 16px;
          font-weight: 600;
        }
      }
      &.buttons {
        // justify-content: flex-end;
        // flex-grow: 1;
        flex-direction: column;
        justify-content: space-between;
        .btn {
          margin-bottom: 12px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .satellite {
          display: flex;
          height: 60px;
          &::v-deep {
            .content {
              display: flex;
              svg {
                width: 40px;
                height: 40px;
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .about {
      height: 100%;
      display: flex;
      flex-direction: column;
      .a-row {
        flex-wrap: wrap;
        margin-bottom: 0;
        &.buttons {
          justify-content: flex-start;
          align-items: stretch;
          flex-direction: column-reverse;
          flex-grow: 2;
          .btn {
            margin: 16px 0 0 0;
          }
        }
        .a-column {
          flex-basis: 50%;
          max-width: 50%;
          padding-bottom: 24px;
        }
      }
    }
  }
}
</style>
